<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  invoices: { type: Array, default: () => [] },
});

defineOptions({ name: 'DetailPaymentsCard' });

const { t } = useI18n();

function currency(amount) {
  return `KES ${Number(amount || 0).toLocaleString()}`;
}

const totalBilled = computed(() =>
  props.invoices.reduce((sum, inv) => sum + Number(inv.amount || 0), 0)
);

const outstanding = computed(() =>
  props.invoices.reduce((sum, inv) => sum + Number(inv.balance || 0), 0)
);
</script>

<template>
  <div>
    <div
      v-for="(invoice, index) in invoices"
      :key="invoice.reference_number || index"
      class="mb-2 border-b border-gray-100 pb-2 last:mb-0 last:border-0"
    >
      <div class="flex items-center justify-between">
        <span class="text-sm font-medium text-gray-900">{{
          invoice.payment_for
        }}</span>
        <span
          class="rounded-full px-2 py-0.5 text-[10px] font-medium"
          :class="
            invoice.status === 'COMPLETE'
              ? 'bg-green-100 text-green-700'
              : 'bg-gray-100 text-gray-600'
          "
        >
          {{ invoice.status }}
        </span>
      </div>
      <p class="text-xs text-gray-500">
        {{ invoice.reference_number }}
        <template v-if="invoice.date_generated">
          · {{ new Date(invoice.date_generated).toLocaleDateString() }}
        </template>
      </p>
      <p class="mt-1 text-sm font-semibold text-gray-900">
        {{ currency(invoice.amount) }}
      </p>
    </div>
    <div class="mt-2 space-y-1 border-t border-gray-100 pt-2 text-sm">
      <div class="flex items-center justify-between">
        <span class="text-gray-500">{{
          t('ARDHISASA.LAND_PROCESSES.LAND_REGISTRATION.TOTAL_BILLED')
        }}</span>
        <span class="font-medium text-gray-900">{{
          currency(totalBilled)
        }}</span>
      </div>
      <div class="flex items-center justify-between">
        <span class="text-gray-500">{{
          t('ARDHISASA.LAND_PROCESSES.LAND_REGISTRATION.OUTSTANDING')
        }}</span>
        <span class="font-medium text-gray-900">{{
          currency(outstanding)
        }}</span>
      </div>
    </div>
  </div>
</template>
